import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import { Redirect } from 'react-router-dom';
import SidebarAdmin from '../layout/SidebarAdmin';
import { aggiungiAudio } from '../../actions/audio';


const AggiungiAudio = ({ auth: { user, loading }, alert, audio: { audioElement }, aggiungiAudio }) => {

  useEffect(() => {
    const size = alert.length;
    if (size > 0) {
      if (alert[size - 1].alertType === "success") {
        setAudioData({
          titolo: "",
          codice: "",
          descrizione: "",
          link: ""
        })
      }
    }
  }, [alert]);

  const [audioData, setAudioData] = useState({
    titolo: "",
    codice: "",
    descrizione: "",
    link: ""
  });

  const onChange = e => {
    setAudioData({ ...audioData, [e.target.name]: e.target.value });
  };

  const onSubmitAggiungiAudio = (e) => {
    e.preventDefault();
    aggiungiAudio({ titolo, codice, descrizione, link });
  };

  const { titolo, codice, descrizione, link } = audioData;


  if (user && user.ruolo !== 'admin') {
    return <Redirect to="/login" />;
  }

  return (loading ? <Spinner /> :
    <section className="fd-section wide">
      <div className="w-layout-blockcontainer fd-container null w-container">
        <div className="fd-wrap backend">
          <SidebarAdmin />
          <div>
            <div>
              <div className="w-layout-blockcontainer fd-container backend w-container">
                <div className="fd-wrap">
                  <div className="w100">
                    <div className="_1rem">
                      <div>
                        <h1 className="heading-3">Aggiungi materiale</h1>
                      </div>
                      <div className="call-add-evento">
                        <div className="call-item">
                          <div className="call-item-wrap">
                            <div className="fd-form _100 w-form">
                              <form id="email-form" name="email-form" data-name="Email Form" className="form" aria-label="Email Form" onSubmit={(e) => { onSubmitAggiungiAudio(e) }}>
                                <div className="_100">
                                  <label htmlFor="titolo">Titolo <span class="required">*</span></label>
                                  <input className="input w-input" maxLength="256" name="titolo" data-name="titolo"
                                    placeholder="Inserisci il titolo" type="text" id="titolo" value={titolo} required={true} onChange={e => onChange(e)} />
                                </div>
                                <div className="_100">
                                  <label htmlFor="descrizione">Descrizione</label>
                                  <input className="input w-input" maxLength="5000" name="descrizione" data-name="descrizione"
                                    placeholder="Inserisci descrizione" type="text" id="descrizione" value={descrizione} onChange={e => onChange(e)} />
                                </div>
                                <div className="_100">
                                  <label htmlFor="codice">Codice (Vuoi incorporare un video da Youtube? Sulla pagina del video Youtube clicca su CONDIVIDI, poi sul pulsante INCORPORA e poi sul pulsante COPIA, copia qui il codice fornito)</label>
                                  <textarea placeholder="Inserisci codice" maxLength="5000" id="codice" name="codice" data-name="codice" className="input w-input" value={codice} onChange={e => onChange(e)}></textarea>
                                </div>
                                <div className="_100">
                                  <label htmlFor="link">Link (Vuoi aggiungere un pulsante con un link? Inserire qui l’URL)</label>
                                  <input className="input w-input" maxLength="256" name="link" data-name="link"
                                    placeholder="Inserisci link" type="text" id="link" value={link} onChange={e => onChange(e)} />
                                </div>
                                <input type="submit" data-wait="Un attimo..." className="submit-button w-button" value="Aggiungi" />
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
};

AggiungiAudio.propTypes = {
  auth: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  agenda: PropTypes.func.isRequired,
  aggiungiAudio: PropTypes.func.isRequired

}

const mapStateToProps = state => ({
  auth: state.auth,
  alert: state.alert,
  audio: state.audio
});

export default connect(mapStateToProps, { aggiungiAudio })(AggiungiAudio);